export default __webpack_public_path__ + "static/media/DraculaCh8.abc2ee8c.svg";